import { X, Keyboard } from 'lucide-react';

interface KeyboardShortcutsProps {
  isOpen: boolean;
  onClose: () => void;
}

export function KeyboardShortcuts({ isOpen, onClose }: KeyboardShortcutsProps) {
  if (!isOpen) return null;

  const shortcuts = [
    { keys: ['Ctrl', 'S'], description: 'Save draft' },
    { keys: ['Ctrl', 'D'], description: 'Validate' },
    { keys: ['Ctrl', 'E'], description: 'Export JSON' },
    { keys: ['Ctrl', 'O'], description: 'Add new order' },
    { keys: ['Ctrl', 'L'], description: 'Add line item' },
    { keys: ['Tab'], description: 'Move to next field' },
    { keys: ['Shift', 'Tab'], description: 'Move to previous field' },
    { keys: ['Enter'], description: 'Move to next field' },
    { keys: ['Esc'], description: 'Close dialogs' },
    { keys: ['?'], description: 'Show shortcuts (this dialog)' },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <Keyboard size={20} className="text-indigo-600" />
            <h3 className="font-semibold text-gray-900">Keyboard Shortcuts</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 p-1"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-4 max-h-96 overflow-y-auto">
          <div className="space-y-2">
            {shortcuts.map((shortcut, index) => (
              <div key={index} className="flex items-center justify-between py-2">
                <span className="text-sm text-gray-700">{shortcut.description}</span>
                <div className="flex items-center gap-1">
                  {shortcut.keys.map((key, keyIndex) => (
                    <span key={keyIndex}>
                      <kbd className="kbd">{key}</kbd>
                      {keyIndex < shortcut.keys.length - 1 && (
                        <span className="text-gray-400 mx-1">+</span>
                      )}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="px-4 py-3 bg-gray-50 border-t border-gray-200 rounded-b-lg">
          <p className="text-xs text-gray-600">
            Press <kbd className="kbd">Esc</kbd> to close this dialog
          </p>
        </div>
      </div>
    </div>
  );
}
